import Image from "next/image";
import React from "react";
import ToBeReplaces from "../../../public/assets/images/winners-trophy.png";

interface FinalistTwo {
  name: string;
  business: string;
  title: string;
}

interface finalistTwoProps {
  finalistTwo: FinalistTwo;
}

export default function FinalistTwoCard(props: finalistTwoProps) {
  const { finalistTwo } = props;
  return (
    <div className="w-[300px] max-w-[300px] bg-grey-light my-12 pt-5 px-5 relative mx-auto">
      <div className="h-32 w-1/2 md:w-full xl:w-1/2">
        <h4 className="text-2xl openSans leading-7 font-bold">
          {finalistTwo.name}
        </h4>
        <p className="text-gray-600 italic py-3 text-sm">
          {finalistTwo.business}
        </p>
      </div>
      <div className="absolute md:hidden xl:block -top-9 right-0 sm:right-8">
        <Image
          src={ToBeReplaces}
          width={130}
          height={193}
          alt="logo trophy of winners"
        />
      </div>
      <div className="text-center">
        <div className="text-white bg-blue-500 transition-color px-3 py-3 font-semibold flex justify-center">
          {finalistTwo.title}
        </div>
      </div>
    </div>
  );
}
